"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageManager = void 0;
class LocalStorageManager {
    constructor(handler, saleorState) {
        this.getHandler = () => {
            return this.handler;
        };
        this.addItemToCart = (variantId, quantity) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            let variant = lines.find((variant) => variant.variant.id === variantId);
            const alteredLines = lines.filter((variant) => variant.variant.id !== variantId);
            const newVariantQuantity = variant ? variant.quantity + quantity : quantity;
            if (variant) {
                variant.quantity = newVariantQuantity;
                alteredLines.push(variant);
            }
            else {
                variant = {
                    quantity,
                    variant: {
                        id: variantId,
                    },
                };
                alteredLines.push(variant);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.removeItemFromCart = (variantId) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            const variant = lines.find((variant) => variant.variant.id === variantId);
            const alteredLines = lines.filter((variant) => variant.variant.id !== variantId);
            if (variant) {
                variant.quantity = 0;
                alteredLines.push(variant);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.subtractItemFromCart = (variantId) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            const variant = lines.find((variant) => variant.variant.id === variantId);
            const alteredLines = lines.filter((variant) => variant.variant.id !== variantId);
            const newVariantQuantity = variant ? variant.quantity - 1 : 0;
            if (variant) {
                variant.quantity = newVariantQuantity;
                alteredLines.push(variant);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.updateItemInCart = (variantId, quantity) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            const variant = lines.find((variant) => variant.variant.id === variantId);
            const alteredLines = lines.filter((variant) => variant.variant.id !== variantId);
            if (variant) {
                variant.quantity = quantity;
                alteredLines.push(variant);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.handler = handler;
        this.saleorState = saleorState;
    }
}
exports.LocalStorageManager = LocalStorageManager;
//# sourceMappingURL=index.js.map